import React__default from 'react';
import Box from '../Box/Box.js';

const Counter = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Box, null, children);
};
Counter.displayName = "Counter";
Counter.displayName = 'Count';

export { Counter };
